import _regeneratorRuntime from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// 设置文件
import setting from '@/setting.js';
export default {
  namespaced: true,
  state: {
    // 顶栏菜单
    header: [],
    // 侧栏菜单
    aside: [],
    // 侧边栏收缩
    asideCollapse: setting.menu.asideCollapse,
    // 侧边栏折叠动画
    asideTransition: setting.menu.asideTransition
  },
  actions: {
    /**
     * 设置侧边栏展开或者收缩
     * @param {Object} context
     * @param {Boolean} collapse is collapse
     */
    asideCollapseSet: function asideCollapseSet(_ref, collapse) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var state, dispatch;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              state = _ref.state, dispatch = _ref.dispatch;
              // store 赋值
              state.asideCollapse = collapse;
              // 持久化
              _context.next = 4;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideCollapse',
                value: state.asideCollapse,
                user: true
              }, {
                root: true
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    /**
     * 切换侧边栏展开和收缩
     * @param {Object} context
     */
    asideCollapseToggle: function asideCollapseToggle(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var state, dispatch;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref2.state, dispatch = _ref2.dispatch;
              // store 赋值
              state.asideCollapse = !state.asideCollapse;
              // 持久化
              _context2.next = 4;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideCollapse',
                value: state.asideCollapse,
                user: true
              }, {
                root: true
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /**
     * 设置侧边栏折叠动画
     * @param {Object} context
     * @param {Boolean} transition is transition
     */
    asideTransitionSet: function asideTransitionSet(_ref3, transition) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var state, dispatch;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              state = _ref3.state, dispatch = _ref3.dispatch;
              // store 赋值
              state.asideTransition = transition;
              // 持久化
              _context3.next = 4;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideTransition',
                value: state.asideTransition,
                user: true
              }, {
                root: true
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    /**
     * 切换侧边栏折叠动画
     * @param {Object} context
     */
    asideTransitionToggle: function asideTransitionToggle(_ref4) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var state, dispatch;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              state = _ref4.state, dispatch = _ref4.dispatch;
              // store 赋值
              state.asideTransition = !state.asideTransition;
              // 持久化
              _context4.next = 4;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'menu.asideTransition',
                value: state.asideTransition,
                user: true
              }, {
                root: true
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    /**
     * 持久化数据加载侧边栏设置
     * @param {Object} context
     */
    asideLoad: function asideLoad(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var state, dispatch, menu;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              state = _ref5.state, dispatch = _ref5.dispatch;
              _context5.next = 3;
              return dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'menu',
                defaultValue: setting.menu,
                user: true
              }, {
                root: true
              });
            case 3:
              menu = _context5.sent;
              state.asideCollapse = menu.asideCollapse !== undefined ? menu.asideCollapse : setting.menu.asideCollapse;
              state.asideTransition = menu.asideTransition !== undefined ? menu.asideTransition : setting.menu.asideTransition;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  },
  mutations: {
    /**
     * @description 设置顶栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    headerSet: function headerSet(state, menu) {
      // store 赋值
      state.header = menu;
    },
    /**
     * @description 设置侧边栏菜单
     * @param {Object} state state
     * @param {Array} menu menu setting
     */
    asideSet: function asideSet(state, menu) {
      // store 赋值
      state.aside = menu;
    }
  }
};